import React from "react";
import { Route, Routes } from "react-router-dom";
import Tabs from "../global/PageTabs";
import ConfigureOrganizationCreateScreen from "../configureOrganization/ConfigureOrganizationCreateScreen";
import ConfigureOrganizationListScreen from "../configureOrganization/ConfigureOrganizationListScreen";
import ConfigurePluginScriptListScreen from "../configurePluginOrScript/ConfigurePluginScriptListScreen";
import { Settings } from "react-feather";
import ConfigureOrganizationEditScreen from "../configureOrganization/ConfigureOrganizationEditScreen";
import ConfigDocumentsListScreen from "./ConfigDocumentsListScreen";

const tabs = [
  { key: "organization", label: "Organizations" },
  { key: "plugin", label: "Plugins" },
  { key: "documents", label: "Documents" },
];

const ConfigRouter = () => {
  return (
    <div>
      <Tabs mode="wrap" tabs={tabs} icon={Settings} link />
      <Routes>
        <Route
          path="organization"
          element={<ConfigureOrganizationListScreen />}
        />
        <Route
          path="organization/:id"
          element={<ConfigureOrganizationEditScreen />}
        />
        <Route
          path="organization/new"
          element={<ConfigureOrganizationCreateScreen />}
        />
        <Route path="documents" element={<ConfigDocumentsListScreen />} />
        <Route path="plugin" element={<ConfigurePluginScriptListScreen />} />
      </Routes>
    </div>
  );
};

export default ConfigRouter;
